module.exports = __webpack_public_path__ + "img/logo-branco.f6441f65.png";